__turbopack_context__.v({
  "mapRoot": "MarketplaceMap-module__R1U8Rq__mapRoot",
});
